export const TOGGLE_IS_FETCHING = 'TOGGLE_IS_FETCHING';

export const ERROR = 'ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const GET_FIRST_USERS = 'GET_FIRST_USERS';
export const GET_NEXT_USERS = 'GET_NEXT_USERS';

export const GET_POSITIONS = 'GET_POSITIONS';

export const TOGGLE_MODAL = 'TOGGLE_MODAL';
